import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { ApplicationUrlSettings } from '../../settings/ApplicationUrlSettings';
import { HttpWrapperService } from '../http-wrapper/http-wrapper.service';

@Injectable()
export class UserService {

  constructor(private http: HttpWrapperService) {

  }


  getTrackingLink(tripid){
    var token = JSON.parse(localStorage.getItem('login')).token;
    const headers = new Headers({
      'Authorization': `Bearer ${token}`
    });
    var url = `${ApplicationUrlSettings.NODE_API_URL}users/tracking-link?tripid=${tripid}`;
    return this.http.get(url,{headers:headers}).toPromise().then(res => res.json());    
  }

  getRatings(userid, tripid) {
    var url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.GET_RATINGS + "/" + userid + "/" + tripid;
    return this.http.get(url).toPromise().then(res => res.json());
  }

  rateTrip(body) {
    var url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.RATE_TRIP;
    return this.http.post(url, body).toPromise().then(res => res.json());
  }

  getUserInfo(email) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}${ApplicationUrlSettings.USER_INFO}/${email}`;
    return this.http.get(url).toPromise().then(res => res.json());
  }


  submitChangeRequest(body): Promise<any> {
    var url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.CHANGE_REQUEST;
    return this.http.post(url, body).toPromise().then(res => res.json());
  }

  getPendingAddrChange(userid: number): Promise<any> {

    var url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.CHECK_PEND_ADDR_CHANGE + "/" + userid;
    return this.http.get(url).toPromise().then(res => res.json());
  }

  approveAddressChange(userid) {

    var url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.APPROVE_ADDR + "/" + userid;
    return this.http.get(url).toPromise().then(res => res.json());
  }

  declineChangeRequest(userid) {

    var url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.DECLINE_ADDR + "/" + userid;
    return this.http.get(url).toPromise().then(res => res.json());
  }


  getPendingChangeRequests() {

    var url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.GET_ALL_PEND_ADDR_CHANGE;
    return this.http.get(url).toPromise().then(res => res.json());
  }

  removeUserFromRun(body): Promise<string> {

    var url = ApplicationUrlSettings.PHP_API_URL + ApplicationUrlSettings.REMOVE_USER_RUN;
    return this.http.post(url, JSON.stringify(body)).toPromise().then(res => res.json());
  }

  cancelPickupByTrip(tripid,employeeid){
    var url = `${ApplicationUrlSettings.NODE_API_URL}users/cancel-pickup?tripid=${tripid}&userid=${employeeid}`;
    return this.http.delete(url).toPromise().then(res => res.json());
  }

  cancelPickup(id:number){
    var url = `${ApplicationUrlSettings.NODE_API_URL}users/cancel-pickup?id=${id}`;
    return this.http.delete(url).toPromise().then(res => res.json());
  }

  deletePickupByIds(ids: Array<number>) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}users/pickup-info?ids=${ids.join(",")}`;
    return this.http.delete(url).toPromise().then(res => res.json());
  }

  updatePickupByIds(ids: Array<number>, newTime: string) {
    var body = {
      "ids": ids,
      "newTime": newTime
    };
    var url = `${ApplicationUrlSettings.NODE_API_URL}users/pickup-info`;
    return this.http.patch(url, body).toPromise().then(res => res.json());
  }

  moveUserFromRun(body): Promise<string> {
    var url = ApplicationUrlSettings.PHP_API_URL + ApplicationUrlSettings.MOVE_USER_RUN;
    return this.http.post(url, JSON.stringify(body)).toPromise().then(res => res.json());
  }



  getAllUserTravelInfo(body: any): Promise<string> {
    var url = ApplicationUrlSettings.PHP_API_URL + ApplicationUrlSettings.GET_ALL_USER_TRAVEL_INFO;
    return this.http.post(url, JSON.stringify(body)).toPromise().then(res => res.json());
  }

  getUserPickupInfo(employeeid:string,start: string, end: string, companyid: number){
    var url = `${ApplicationUrlSettings.NODE_API_URL}users/pickup-info?employeeid=${employeeid}&start=${start}&end=${end}&companyid=${companyid}`;
    return this.http.get(url).toPromise().then(res => res.json());
  }

  getPickupInfo(start: string, end: string, companyid: number, locationid: number, type:string): Promise<any> {
    var url = `${ApplicationUrlSettings.NODE_API_URL}users/pickup-info?start=${start}&end=${end}&companyid=${companyid}&locationid=${locationid}&type=${type}`;
    return this.http.get(url).toPromise().then(res => res.json());
  }

  checkEmailExist(email: string): Promise<string> {
    var url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.CHECK_EMAIL_EXIST + "/" + email;
    console.log(url);
    return this.http.get(url)
      .toPromise().then(res => res.json());
  }

  createUser(user: any): Promise<string> {
    return this.http.post(ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.USERS, user)
      .toPromise().then(res => res.json());
  }

  decodeRidePass(data){
    var url = `${ApplicationUrlSettings.NODE_API_URL}users/decode-pass?data=${data}`;
    return this.http.get(url)
    .toPromise().then(res => res.json());

  }

  claim(user: any): Promise<string> {
    var url = `${ApplicationUrlSettings.NODE_API_URL}${ApplicationUrlSettings.CLAIM}`;
    return this.http.patch(url, user)
      .toPromise().then(res => res.json());
  }

  completeRegistration(user: any): Promise<string> {
    var url = `${ApplicationUrlSettings.NODE_API_URL}${ApplicationUrlSettings.COMPLETE_USER_REG}`;
    return this.http.patch(url, user)
      .toPromise().then(res => res.json());
  }

  loginUser(email, password): Promise<string> {

    var body = {
      "email": email,
      "password": password
    };
    var url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.USER_LOGIN;
    return this.http.post(url, body).toPromise().then(res => res.json());
  }

  updateUserLatLng(address, lat, lng): Promise<string> {

    let body = {
      address: address,
      lat: lat,
      lng: lng
    }

    return this.http.post(ApplicationUrlSettings.PHP_API_URL + "insert", JSON.stringify(body)).toPromise().then(res => res.json());
  }


  getWeeks(companyid = null, locationid = null): Promise<string> {

    var url = "";
    if (companyid && locationid) {
      url = ApplicationUrlSettings.PHP_API_URL + ApplicationUrlSettings.GET_WEEKS + "/" + companyid + "/" + locationid;
    } else if (companyid) {
      url = ApplicationUrlSettings.PHP_API_URL + ApplicationUrlSettings.GET_WEEKS + "/" + companyid;
    } else if (locationid) {
      url = ApplicationUrlSettings.PHP_API_URL + ApplicationUrlSettings.GET_WEEKS + "/" + locationid;
    }
    else {
      var url = ApplicationUrlSettings.PHP_API_URL + ApplicationUrlSettings.GET_WEEKS;
    }

    return this.http.get(url).toPromise().then(res => res.json());
  }

  publishReport(body): Promise<string> {
    var url = ApplicationUrlSettings.PHP_API_URL + ApplicationUrlSettings.PUBLISH_REPORT;
    return this.http.post(url, JSON.stringify(body)).toPromise().then(res => res.json());
  }

  getUserWeeks(employeeid: string): Promise<string> {
    var url = ApplicationUrlSettings.PHP_API_URL + ApplicationUrlSettings.GET_USER_WEEKS + "/" + employeeid;
    return this.http.get(url).toPromise().then(res => res.json());
  }

  getBatchUploadTemplateForAll(): Promise<string> {
    var url = ApplicationUrlSettings.PHP_API_URL + ApplicationUrlSettings.GET_BATCH_UPLOAD_TEMPLATE_FOR_ALL;
    return this.http.get(url).toPromise().then(res => res.json());
  }

  getRegisteredUsers(compid, locid) {

    var url = ApplicationUrlSettings.PHP_API_URL + ApplicationUrlSettings.GET_REGISTERED_USERS + "/" + compid + "/" + locid;
    return this.http.get(url).toPromise().then(res => res.json());
  }

  getTotalUsers(compid, locid): Promise<string> {

    var url = ApplicationUrlSettings.PHP_API_URL + ApplicationUrlSettings.GET_TOTAL_USERS + "/" + compid + "/" + locid;
    return this.http.get(url).toPromise().then(res => res.json());
  }

  getUnregisteredUsers(compid, locid) {

    var url = ApplicationUrlSettings.PHP_API_URL + ApplicationUrlSettings.GET_UNREGISTERED_USERS + "/" + compid + "/" + locid;
    return this.http.get(url).toPromise().then(res => res.json());
  }

  getUncachedUsers(compid, locid) {

    var url = ApplicationUrlSettings.PHP_API_URL + ApplicationUrlSettings.GET_UNCACHED_USERS + "/" + compid + "/" + locid;
    return this.http.get(url).toPromise().then(res => res.json());
  }

  static isUserLoggedIn(){
    try{
      var result = JSON.parse(window.localStorage.getItem("login"));
      if(result){
        return true; 
      }
    }catch(e){
      return false;
    }
    return false;
  }

  getUserData(): any {
    return JSON.parse(window.localStorage.getItem("login"));
  }

  getUserTrips(userid, start, end) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}${ApplicationUrlSettings.TRIP}/user/${userid}?startDate=${start}&endDate=${end}`;
    return this.http.get(url).toPromise().then(res => res.json());
  }

  storeUserData(data) {
    window.localStorage.setItem("login", JSON.stringify(data));
  }

  updateUserPayload(payload) {
    let data = this.getUserData();
    data.payload = payload;
    window.localStorage.setItem("login", JSON.stringify(data));
  }


  getUsers(id: number = null) {
    var urlPrefix = `${ApplicationUrlSettings.NODE_API_URL}users`;
    var fullUrl = id != null ? urlPrefix + "/" + id : urlPrefix;
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    return this.http.get(urlPrefix,{ headers:headers}).toPromise().then(res => res.json());
  }

  isUserRegistered(id) {
    var url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.IS_USER_REG + "/" + id;
    return this.http.get(url).toPromise().then(res => res.json());
  }

  aukwhxbasuaksyaj(x: any) {
    var url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.aukwhxbasuaksyaj + "/" + x;
    return this.http.get(url).toPromise().then(res => res.json());
  }

  getUserByEmail(email) {
    var urlPrefix = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.GET_USER_BY_EMAIL;
    var fullUrl = urlPrefix + "/" + email;
    return this.http.get(fullUrl).toPromise().then(res => res.json());
  }

  getUserByEmployeeId(id: number = null) {

    var urlPrefix = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.GET_USER_BY_EMP_ID;
    var fullUrl = urlPrefix + "/" + id;
    return this.http.get(fullUrl).toPromise().then(res => res.json());
  }

  checkPickupExists(date,company,location,type,employeeid){
    var url = `${ApplicationUrlSettings.NODE_API_URL}users/pickup-info/exists?date=${date}&companyid=${company}&locationid=${location}&pickuptype=${type}&employeeid=${employeeid}`;
    return this.http.get(url).toPromise().then(res => res.json());
  }

  requestPickup(companyid:any,pickupdata:Array<any>,pickupType){
    var url = `${ApplicationUrlSettings.NODE_API_URL}users/pickup-info`;
    return this.http.post(url,{companyid:companyid,schedules:pickupdata,pickuptype:pickupType}).toPromise().then(res => res.json());
  }

  batchPickupUpload(companyid:any,pickupdata:Array<any>,pickupType,overwrite){
    var url = `${ApplicationUrlSettings.NODE_API_URL}users/pickup-info/batchupload`;
    return this.http.post(url,{companyid:companyid,schedules:pickupdata,pickuptype:pickupType,overwrite:overwrite}).toPromise().then(res => res.json());
  }

  getUserByCompany(companyid, locationid = null) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}users/${companyid}`;
    if(locationid){
      url += `/${locationid}`
    }
    return this.http.get(url).toPromise().then(res => res.json());
  }

  getReportDetails(body: any, multi = "0"): Promise<any> {
    var url = `${ApplicationUrlSettings.NODE_API_URL}${ApplicationUrlSettings.GET_REPORT_DETAILS}?multi=${multi}`
    return this.http.post(url, body).toPromise().then(res => res.json());
  }

  addUserPickup(body: Array<any>): Promise<string> {
    var url = ApplicationUrlSettings.PHP_API_URL + ApplicationUrlSettings.ADD_USER_PICKUP;
    return this.http.post(url, JSON.stringify(body)).toPromise().then(res => res.json());
  }

  generateQRCode(email) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}${ApplicationUrlSettings.BUS_PAS}/${email}`;
    return this.http.post(url, null).toPromise();
  }

  bulkCacheUsers(body: any) {

    var url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.BULK_CACHE;
    return this.http.post(url, body).toPromise().then(res => res.json());
  }


  sendPasswordResetLink(email: any) {
    var url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.RESET_PASSWORD + "/" + email;
    return this.http.get(url).toPromise().then(res => res.json());
  }

  resetPassword(link, pass) {
    var url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.SET_NEW_PASSWORD;
    var body = {
      link: link,
      pass: pass
    };
    return this.http.post(url, body).toPromise().then(res => res.json());
  }

  sendBulkRegEmails(body: any) {

    var url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.BULK_REG_EMAIL;
    return this.http.post(url, body).toPromise().then(res => res.json());
  }

  sendRegEmail(body: any) {
    var url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.REG_EMAIL;
    return this.http.post(url, body).toPromise().then(res => res.json());
  }

  updateUserInfo(user:any){
    var url = `${ApplicationUrlSettings.NODE_API_URL}users`;
    return this.http.patch(url,user).toPromise().then(res => res.json())
  }

  //PHP API version Will soon be discontinued
  updateUser(user: any): Promise<string> {

    var url = ApplicationUrlSettings.PHP_API_URL + ApplicationUrlSettings.UPDATE_USER;
    return this.http.put(url, JSON.stringify(user)).toPromise().then(res => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/services/user-service/user.service.ts